import { IAppState } from '../../common/state';

export const selectKp = (state: IAppState) => state.results.kp;
